import { ListChecks, MessageSquareText, Scale } from 'lucide-react-native';

import { WIZARD_STEP_ORDER, type WizardStepKey } from '../../model/step';
import { REPLY_DRAFT_COPY } from '../copy';

import type { WizardStep } from '@/components/wizard/WizardSteps';

const STEP_ICONS = { card: Scale, review: ListChecks } satisfies Record<
  WizardStepKey,
  WizardStep['icon']
>;

/**
 * The reply draft's steps as the stepper draws them, in walking order, ending
 * with reviewing the reply in the message box. That step happens in the
 * composer after the draft closes, so the wizard never stands on it; it is
 * drawn so the expert sees the reply still comes back to them to read and
 * send, rather than taking the last button for sending.
 */
export const REPLY_DRAFT_STEPS: readonly WizardStep<WizardStepKey | 'compose'>[] = [
  ...WIZARD_STEP_ORDER.map((key) => ({
    key,
    label: REPLY_DRAFT_COPY.steps[key],
    icon: STEP_ICONS[key],
  })),
  { key: 'compose', label: REPLY_DRAFT_COPY.composeStep, icon: MessageSquareText },
];
